import type { RoomMember } from "~/lib/matrix";

export type OrgRoster =
  | { status: "pending" }
  | { status: "error" }
  | { status: "ready"; joinedUserIds: ReadonlySet<string> };

export function dmBelongsToOrg(
  peerIds: readonly string[],
  selfId: string,
  roster: OrgRoster,
): boolean {
  const peers = [...new Set(peerIds)].filter((id) => id !== selfId);
  return (
    roster.status === "ready" &&
    peers.length > 0 &&
    peers.every((id) => roster.joinedUserIds.has(id))
  );
}

export function isJoinedMember(member: RoomMember): boolean {
  return member.membership === "join";
}

// A row is admitted only when every non-self participant is an explicit join
// that the org roster certifies. A participant whose membership is absent,
// unrecognised, or any non-join state is not certifiable, so the row is
// excluded rather than having that participant silently dropped — a mixed
// group with an uncertified outsider must never be admitted.
export function dmEligibleForOrg(
  members: readonly RoomMember[],
  selfId: string,
  roster: OrgRoster,
): boolean {
  if (roster.status !== "ready") return false;
  const nonSelf = members.filter((member) => member.userId !== selfId);
  if (nonSelf.length === 0) return false;
  return nonSelf.every(
    (member) => isJoinedMember(member) && roster.joinedUserIds.has(member.userId),
  );
}
